import { getPortalAccountId, getPortalInstanceId } from './utils/metadata';
// @ts-expect-error Untyped module
import Cookies from 'js-cookie';
export default function createPortalsFetchClient(prefix) {
  return function portalsFetchClient(input, init) {
    const originalBody = JSON.parse(init.body.toString());
    const clientInfo = {
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId()
    };
    return fetch(`${prefix}${input}`, {
      method: 'POST',
      headers: Object.assign({}, init.headers, {
        'X-Hs-Membership-Csrf': Cookies.get('hs-membership-csrf')
      }),
      body: JSON.stringify(Object.assign({}, originalBody, clientInfo))
    });
  };
}